var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#d7d3d1","d":"M809.9 0H67.5C30.2 0 0 30.2 0 67.5V810c0 37.3 30.2 67.5 67.5 67.5H810c37.3 0 67.5-30.2 67.5-67.5V67.6C877.5 30.3 847.3.1 810 .1l-.1-.1Zm0 810H67.5V67.6H810v742.5l-.1-.1ZM303.7 371.3v270c0 18.6-15.1 33.8-33.8 33.8s-33.8-15.1-33.8-33.8v-270c0-18.6 15.1-33.8 33.8-33.8s33.8 15.1 33.8 33.8Zm371.2 118.1v151.9c0 18.6-15.1 33.8-33.8 33.8s-33.8-15.1-33.8-33.8V489.4c0-46.6-37.8-84.4-84.4-84.4s-84.4 37.8-84.4 84.4v151.9c0 18.6-15.1 33.8-33.8 33.8s-33.8-15.1-33.8-33.8v-270c0-18.6 15.3-33.7 33.9-33.6 15.6 0 29.1 10.9 32.7 26.1 69.4-47.1 163.9-29 210.9 40.4 17.1 25.1 26.2 54.8 26.2 85.2h.3ZM320.6 253.2c0 28-22.7 50.6-50.6 50.6s-50.6-22.7-50.6-50.6 22.7-50.6 50.6-50.6 50.6 22.7 50.6 50.6Z"}));
}

Linkedin.defaultProps = {"fill":"currentColor","viewBox":"0 0 877.5 877.5 "};

module.exports = Linkedin;

Linkedin.default = Linkedin;
